import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './WrappedTextValue.css';

const block = 'wrapped-text-value';

export const WrappedTextValue: React.FC = React.memo(({ children }) => {
    return <span className={Bem.cls(block)}>{children}</span>;
});
